export default "__VITE_ASSET__B0$Qo9X5__"